/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './survey-question.reducer';

export const SurveyQuestion = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const surveyQuestionList = useAppSelector(state => state.surveyQuestion.entities);
  const loading = useAppSelector(state => state.surveyQuestion.loading);
  const totalItems = useAppSelector(state => state.surveyQuestion.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="survey-question-heading" data-cy="SurveyQuestionHeading">
        <Translate contentKey="tinyMedicRestApp.surveyQuestion.home.title">Survey Questions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.surveyQuestion.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/survey-question/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.surveyQuestion.home.createLabel">Create new Survey Question</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.surveyQuestion.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {surveyQuestionList && surveyQuestionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('parentId')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.parentId">Parent Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('parentId')} />
                </th>
                <th className="hand" onClick={sort('questionName')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.questionName">Question Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('questionName')} />
                </th>
                <th className="hand" onClick={sort('questionSubtext')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.questionSubtext">Question Subtext</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('questionSubtext')} />
                </th>
                <th className="hand" onClick={sort('questionRequired')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.questionRequired">Question Required</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('questionRequired')} />
                </th>
                <th className="hand" onClick={sort('answerRequired')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.answerRequired">Answer Required</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('answerRequired')} />
                </th>
                <th className="hand" onClick={sort('allowMutipleOptionSurveyAnswer')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.allowMutipleOptionSurveyAnswer">
                    Allow Mutiple Option Survey Answer
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allowMutipleOptionSurveyAnswer')} />
                </th>
                <th className="hand" onClick={sort('dependentQuestionId')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.dependentQuestionId">Dependent Question Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dependentQuestionId')} />
                </th>
                <th className="hand" onClick={sort('dependentQuestionOptionId')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.dependentQuestionOptionId">Dependent Question Option Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dependentQuestionOptionId')} />
                </th>
                <th className="hand" onClick={sort('dependentAnswerId')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.dependentAnswerId">Dependent Answer Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dependentAnswerId')} />
                </th>
                <th className="hand" onClick={sort('sortOrder')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.sortOrder">Sort Order</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sortOrder')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.optionGroup">Option Group</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.surveySection">Survey Section</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surveyQuestion.inputType">Input Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {surveyQuestionList.map((surveyQuestion, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/survey-question/${surveyQuestion.id}`} color="link" size="sm">
                      {surveyQuestion.id}
                    </Button>
                  </td>
                  <td>{surveyQuestion.parentId}</td>
                  <td>{surveyQuestion.questionName}</td>
                  <td>{surveyQuestion.questionSubtext}</td>
                  <td>{surveyQuestion.questionRequired ? 'true' : 'false'}</td>
                  <td>{surveyQuestion.answerRequired ? 'true' : 'false'}</td>
                  <td>{surveyQuestion.allowMutipleOptionSurveyAnswer ? 'true' : 'false'}</td>
                  <td>{surveyQuestion.dependentQuestionId}</td>
                  <td>{surveyQuestion.dependentQuestionOptionId}</td>
                  <td>{surveyQuestion.dependentAnswerId}</td>
                  <td>{surveyQuestion.sortOrder}</td>
                  <td>{surveyQuestion.active ? 'true' : 'false'}</td>
                  <td>{surveyQuestion.cursor}</td>
                  <td>{surveyQuestion.lastupdated}</td>
                  <td>{surveyQuestion.microSec}</td>
                  <td>{surveyQuestion.timestampentry}</td>
                  <td>
                    {surveyQuestion.optionGroup ? (
                      <Link to={`/survey-option-group/${surveyQuestion.optionGroup.id}`}>{surveyQuestion.optionGroup.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {surveyQuestion.surveySection ? (
                      <Link to={`/survey-sections/${surveyQuestion.surveySection.id}`}>{surveyQuestion.surveySection.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {surveyQuestion.inputType ? (
                      <Link to={`/survey-input-type/${surveyQuestion.inputType.id}`}>{surveyQuestion.inputType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/survey-question/${surveyQuestion.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/survey-question/${surveyQuestion.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/survey-question/${surveyQuestion.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.home.notFound">No Survey Questions found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={surveyQuestionList && surveyQuestionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SurveyQuestion;
